import { useEffect, useState } from "@/utils/hooks/reactUseCustomHooks";
import { Box, Text } from "@dxp-feed/ui";
import React from "react";
import ImageWrapper from "../ImageWrapper";
import { TIME_ZONE, TIME_ZONE_LOCALE } from "@/utils/constant";

const OfferCardBadge = ({ promotions, className }: any) => {
  const [promotionsData, setPromotionsData] = useState<any>({});

  const getDaysDifferenceBetweenDatesEST = (
    startDateUnix: number,
    endDateUnix: number,
  ): number => {
    const startDate = new Date(startDateUnix * 1000);
    const endDate = new Date(endDateUnix * 1000);

    const startAtMidnight = new Date(startDate.toLocaleDateString(TIME_ZONE_LOCALE, { timeZone: TIME_ZONE }));
    const endAtMidnight = new Date(endDate.toLocaleDateString(TIME_ZONE_LOCALE, { timeZone: TIME_ZONE }));

    const diffMs = endAtMidnight.getTime() - startAtMidnight.getTime();
    const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

    return diffDays;
  };


  useEffect(() => {
    if (promotions != undefined && promotions.length > 0) {
      const rewardDescription = promotions[0]?.rewardDescription;
      const rewardValue = promotions[0]?.rewardValue?.toString()?.includes(".")
        ? promotions[0]?.rewardValue?.toString()?.split(".")[0]
        : promotions[0]?.rewardValue;
      const rewardDecimalValue = promotions[0]?.rewardValue
        ?.toString()
        ?.includes(".")
        ? promotions[0]?.rewardValue?.toString()?.split(".")[1]
        : "";
      const rewardApplyTo = promotions[0]?.rewardApplyTo;
      const rewardTrigger = promotions[0]?.rewardTrigger;
      const offerIdentifier = promotions[0]?.offerIdentifier;
      const promotionDescription = promotions[0]?.promotionDescription;
      const numberOfDays = getDaysDifferenceBetweenDatesEST(
        promotions[0]?.promotionStartDate,
        promotions[0]?.promotionEndDate
      );
      const memberType = promotions?.[0]?.memberType ? promotions?.[0]?.memberType : "NNNNNNNNNNNNNNNN";
      const rewardType = promotions?.[0]?.rewardType;
      const source = promotions?.[0]?.promotionSource
      const complianceFlag = promotions?.[0]?.complianceFlag
      
      setPromotionsData({
        rewardDescription,
        rewardValue,
        rewardDecimalValue,
        rewardApplyTo,
        offerIdentifier,
        numberOfDays,
        rewardTrigger,
        memberType,
        rewardType,
        source,
        complianceFlag
      });
    }
  }, [promotions]);
  const renderBadges = () => {
    if (
      promotionsData && 
      promotionsData?.complianceFlag == true &&
      promotionsData?.numberOfDays <= 7 && 
      promotionsData?.rewardType != 7
    ){
      return (
            <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
              <ImageWrapper
                src={"/assets/saveThisWeek.png"}
                alt="saveThisWeek"
                height={52}
                width={52}
                className="w-[52px] h-auto"
              />
            </Box>
          );
    }else if (
      promotionsData && 
      promotionsData?.complianceFlag == false &&
      promotionsData?.numberOfDays <= 7 && 
      promotionsData?.rewardType != 7
    ){
      return (
            <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
              <ImageWrapper
                src={"/assets/weeklySpecial.png"}
                alt="weeklySpecial"
                height={52}
                width={52}
                className="w-[52px] h-auto"
              />
            </Box>
          );
    }else if (
      promotionsData && 
      promotionsData?.numberOfDays > 7 && 
      promotionsData?.rewardType != 7
    ){
      return (
            <Box as="div" className={`${className} absolute left-[10px] bottom-0`}>
              <ImageWrapper
                src={"/assets/lockedPrice.png"}
                alt="lockedPrice"
                height={52}
                width={52}
                className="w-[52px] h-auto"
              />
            </Box>
          );
    }
  };

  return <>{renderBadges()}</>;
};

export default OfferCardBadge;
